function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultTipsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1920",
    d: "M19.411-12.3a9.254 9.254 0 0 0-3.638-.7c-3.849 0-7.7 1.948-11.547 1.948a9.482 9.482 0 0 1-2.9-.429 1.068 1.068 0 0 0-.323-.051.994.994 0 0 0-1.003.995v9.914A.994.994 0 0 0 .589.3a9.249 9.249 0 0 0 3.638.7c3.849 0 7.7-1.948 11.547-1.948a9.482 9.482 0 0 1 2.9.429 1.069 1.069 0 0 0 .323.051A.994.994 0 0 0 20-1.463v-9.914a1 1 0 0 0-.589-.923zM1.5-9.868a10.876 10.876 0 0 0 1.96.279A2 2 0 0 1 1.5-7.978zm0 8.906v-1.493A2 2 0 0 1 3.491-.536 7.548 7.548 0 0 1 1.5-.962zM10-3a2.784 2.784 0 0 1-2.5-3A2.785 2.785 0 0 1 10-9a2.785 2.785 0 0 1 2.5 3A2.784 2.784 0 0 1 10-3zm8.5.868a10.741 10.741 0 0 0-1.7-.268 2 2 0 0 1 1.7-1.54zm0-7.378a2 2 0 0 1-1.744-1.923 7.51 7.51 0 0 1 1.744.4z",
    transform: "translate(0 13)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultTipsIcon);
export default __webpack_public_path__ + "static/media/default-tips-icon.43cae0af.svg";
export { ForwardRef as ReactComponent };